import { render, staticRenderFns } from "./AutomationStatisticsProperty.vue?vue&type=template&id=98b391ee&"
import script from "./AutomationStatisticsProperty.vue?vue&type=script&lang=js&"
export * from "./AutomationStatisticsProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports